import React, { lazy, Suspense } from 'react';
import { Button } from '@seismic/mantle';
import { UploaderLoader } from 'components/shared/UniversalUploader/UploaderLoader';
import { UPLOAD_STATUS } from './constants';

const SeismicUniversalUploaderButton = lazy(() =>
  import(
    /* webpackChunkName: "UUCBtn" */ '@seismic/universal-upload-component'
  ).then(module => ({
    default: module.UniversalUploaderButton,
  })),
);

const UploaderActions = ({
  uploadStatus,
  readOnly,
  showImageLibrary,
  onLibraryButtonClick,
}) => {
  return (
    <div className="seismic-learning-universal-uploader--actions">
      <Suspense fallback={<UploaderLoader />}>
        <SeismicUniversalUploaderButton>
          <Button
            className="uploader--btn"
            label={t('universal_uploader.browse_system')}
            disabled={uploadStatus !== UPLOAD_STATUS.INITIAL || readOnly}
            data-testid="browseSystemButton"
          />
        </SeismicUniversalUploaderButton>
      </Suspense>
      {showImageLibrary && (
        <Button
          className="uploader--btn"
          label={t('universal_uploader.browse_image_library')}
          onClick={onLibraryButtonClick}
          disabled={uploadStatus !== UPLOAD_STATUS.INITIAL || readOnly}
          data-testid="browseLibraryButton"
        />
      )}
    </div>
  );
};

export { UploaderActions };
